<template>
  <div class="imageBrowsing">
    <c-el-page-header :detail="'影像浏览'" />
    <div class="box" v-if="imageBrowsingViewportList.length > 0">
      <!-- 该影像不用于诊断 -->
      <div class="_warn">
        <svg-icon icon-class="warn" />

        <span class="">移动端影像仅供参考，不作为诊断依据</span>
      </div>
      <div class="jianju" :class="{'use-mpr':useMPR}" >
        <div class="imgBox" id="dicomviewer-grid">
          <!-- 序列布局 -->
          <div
            ref="viewportItem"
            v-for="(item, index) in imageBrowsingViewportList"
            :key="index"
            :style="item.style"
            :data-index="index"
            :data-num="0 + '-' + index + '-' + 0"
            :data-total="1"
            :class="{ ac: item.ac }"
            @click="setViewportAc(index, item, imageBrowsingViewportList)"
          >
            <div class="ViewportOverlay">
              <div class="top-left overlay-element">
                <div v-for="(_item, index) in item.topLeft" :key="index">
                  {{ _item }}
                </div>
              </div>
              <div class="top-right overlay-element">
                <div v-for="(_item, index) in item.topRight" :key="index">
                  {{ _item }}
                </div>
              </div>
              <div class="bottom-right overlay-element">
                <div v-for="(_item, index) in item.bottomRight" :key="index">
                  {{ _item }}
                </div>
              </div>
              <div class="bottom-left overlay-element">
                <div v-for="(_item, index) in item.bottomLeft" :key="index">
                  {{ _item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gongNeng">
        <div class="d_three_box" v-if="xuLieIs">
          <div class="d_three">
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(1)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 1 ? 'y_1_s' : 'y_1'"
                class="three_svgDx"
              />
            </div>
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(2)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 2 ? 'y_2_h_s' : 'y_2_h'"
                class="three_svgDx"
              />
            </div>
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(3)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 3 ? 'y_2_l_s' : 'y_2_l'"
                class="three_svgDx"
              />
            </div>
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(4)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 4 ? 'y_3_s' : 'y_3'"
                class="three_svgDx"
              />
            </div>
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(5)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 5 ? 'y_4_s' : 'y_4'"
                class="three_svgDx"
              />
            </div>
            <div class="d_three_img" @click="triggerHandleTypeXuLieFun(6)">
              <svg-icon
                :icon-class="triggerHandleTypeXuLie == 6 ? 'y_6_s' : 'y_6'"
                class="three_svgDx"
              />
            </div>
            <div
              class="d_three_img_huanYuan"
              @click="triggerHandleTypeXuLieFun(1)"
            >
              <svg-icon icon-class="y_huanYuan" class="three_huanYuan" />
            </div>
          </div>
        </div>
        <div class="d_four_box" v-if="ceLiangIs">
          <div class="d_four">
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(1, 'Length')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 1
                    ? 'y_zhiXian_s'
                    : 'y_zhiXian'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 1 }"
              >
                直线
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(2, 'Angle')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 2
                    ? 'y_jiaoDu_s'
                    : 'y_jiaoDu'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 2 }"
              >
                角度
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(3, 'RectangleRoi')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 3
                    ? 'y_juXing_s'
                    : 'y_juXing'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 3 }"
              >
                矩形
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(4, 'EllipticalRoi')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 4
                    ? 'y_tuoYuan_s'
                    : 'y_tuoYuan'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 4 }"
              >
                椭圆
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(9, 'Probe')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 9
                    ? 'probe_s'
                    : 'probe'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 9 }"
              >
                点
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(10, 'FreehandRoi')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 10
                    ? 'freehandRoi_s'
                    : 'freehandRoi'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 10 }"
              >
                范围
              </div>
            </div>

            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(6, 'ArrowAnnotate')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 6
                    ? 'arrowAnnotate_s'
                    : 'arrowAnnotate'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 6 }"
              >
                箭头标注
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(8, 'LineMarkerTool')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 8
                    ? 'lineMarkerTool_s'
                    : 'lineMarkerTool'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 8 }"
              >
                线段标注
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(7, 'TextMarker')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 7
                    ? 'textMarker_s'
                    : 'textMarker'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 7 }"
              >
                文本标注
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeCeLiangFun(5, 'Clear')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_ceLiang == 5
                    ? 'y_qingChu_s'
                    : 'y_qingChu'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_ceLiang == 5 }"
              >
                清除
              </div>
            </div>
          </div>
        </div>
        <div class="d_four_box" v-if="gongJuIs">
          <div class="d_four"> 
            <div
              class="d_two_img"
              @click="triggerHandleTypeGongJuFun(1, 'invert')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 1 ? 'y_fanSe_s' : 'y_fanSe'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 1 }"
              >
                反色
              </div>
            </div>
            <div
              class="d_two_img"
              :class="{'_disable': useMPR }"
              @click="triggerHandleTypeGongJuFun(6, 'StackScroll')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 6 ? 'fanye_s' : 'fanye'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 6 }"
              >
                翻页
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeGongJuFun(5, 'mpr')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 5 ? 'MPR_s' : 'MPR'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 5 }"
              >
                MPR
              </div>
            </div>
            <div
              class="d_two_img"
                :class="{'_disable': useMPR }"
              @click="triggerHandleTypeGongJuFun(2, 'Pan')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 2 ? 'y_yiDong_s' : 'y_yiDong'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 2}"
              >
                移动
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeGongJuFun(3, 'reset')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 3
                    ? 'y_ziShiYing_s'
                    : 'y_ziShiYing'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 3 }"
              >
                自适应
              </div>
            </div>
            <div
              class="d_two_img"
              :class="{'_disable': useMPR }"
              @click="triggerHandleTypeGongJuFun(4, 'playClip')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 4 ? 'y_boFang_s' : 'y_boFang'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 4}"
              >
                播放
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeGongJuFun(7, 'rotateViewport+')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 7 ? 'shunshizhen_s' : 'shunshizhen'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 7}"
              >
                 顺时针 
              </div>
            </div>
            <div
              class="d_two_img"
               @click="triggerHandleTypeGongJuFun(8, 'rotateViewport-')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 8 ? 'nishizhen_s' : 'nishizhen'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 8}"
              >
                 逆时针 
              </div>
            </div>
            <div
              class="d_two_img"
              @click="triggerHandleTypeGongJuFun(9, 'flipViewportHorizontal')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 9? 'shuipingfanzhuan_s' : 'shuipingfanzhuan'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 9}"
              >
                 水平翻转 
              </div>
            </div>
            <div
              class="d_two_img"
               @click="triggerHandleTypeGongJuFun(10, 'flipViewportVertical')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 10 ? 'chuizhifanzhuan_s' : 'chuizhifanzhuan'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 10}"
              >
                 垂直翻转 
              </div>
            </div>
            <div
              class="d_two_img"
               @click="triggerHandleTypeGongJuFun(11, 'jietu')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 11 ? 'xiazai_s' : 'xiazai'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 11}"
              >
                下载截图 
              </div>
            </div>
            <div
              class="d_two_img"
               @click="triggerHandleTypeGongJuFun(12, 'downDCM')"
            >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex_gongJu == 12 ? 'xiazai_s' : 'xiazai'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex_gongJu == 12}"
              >
                下载DCM
              </div>
            </div>
          </div>
        </div>
        <div class="d_one" v-if="!useMPR">
          <div class="d_one_biao">
            <div
              @click="getScrollClick(1)"
              v-if="imageBrowsing.length > 4"
              class="d_one_biao_"
            >
              <svg-icon
                :icon-class="imgTiShiBiaoOne == 1 ? 'd_zuo_s' : 'd_zuo'"
                class="biaoShi"
              />
            </div>
          </div>
          <div class="d_one_center">
            <div
              class="d_one_img"
              ref="tcSfPathWarpper"
              @scroll.passive="getScroll($event)"
            >
              <div
                v-for="(item, index) in imageBrowsing"
                @click="thumbnailClick(index)"
                :key="index"
                class="tcSfPathWarpper"
              >
                <div
                  class="tcSfPathWarpper_s"
                  :class="{ tcSfPathWarpperChe: thumbnailChe == index }"
                >
                  <thumbnailComponentsDZJP
                    :imageIds="item.getDcmFilePath"
                    :id="index"
                  ></thumbnailComponentsDZJP>
                  <div
                    class="tcSfPathWarpperNum"
                    :class="{ tcSfPathWarpperNumChe: thumbnailChe == index }"
                  >
                    {{ index + 1 }}
                  </div>
                  <div
                    class="tcSfPathWarpperFont"
                    :class="{ tcSfPathWarpperFontChe: thumbnailChe == index }"
                  >
                    {{ item.getDcmFilePath.length }}
                  </div>
                  <!-- 进度条 -->
                  <div class="_pa _progress" :class="{'progress-err':errorInfo[0] == index}">
                    <el-progress
                      :percentage="percentagefn(item.percentage, item.getDcmFilePath.length )"
                      :show-text="false"
                      color="#00afb9"
                    ></el-progress>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d_one_biao">
            <div
              @click="getScrollClick(2)"
              v-if="imageBrowsing.length > 4"
              class="d_one_biao_"
            >
              <svg-icon
                :icon-class="imgTiShiBiaoTwo == 1 ? 'd_you_s' : 'd_you'"
                class="biaoShi"
              />
            </div>
          </div>
        </div>
        <div class="d_two_box">
          <div class="d_two">
            <div class="d_two_img" @click="triggerHandleType(1)"   :class="{'_disable': useMPR }" >
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex == 1 ? 'y_xuLie_s' : 'y_xuLie'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex == 1 }"
              >
                序列
              </div>
            </div>
            <div class="d_two_img" @click="triggerHandleType(2)">
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex == 2
                    ? 'y_tiaoChuang_s'
                    : 'y_tiaoChuang'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex == 2 }"
              >
                调窗
              </div>
              <div class="tiaoChuangChild" v-if="tiaoChuangIs">
                <ul>
                  <li
                    v-for="(item, i) in imageTiaoChuang"
                    @click.stop="tiaoChuangChildFun(item, i)"
                    :key="i"
                    :class="{ tiaoChuangCheng: tiaoChuangChe === i }"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="d_two_img" @click="triggerHandleType(3)">
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex == 3 ? 'y_ceLiang_s' : 'y_ceLiang'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex == 3 }"
              >
                测量
              </div>
            </div>
            <div class="d_two_img" @click="triggerHandleType(4)">
              <svg-icon
                :icon-class="
                  triggerHandleTypeIndex == 4 ? 'y_gongJu_s' : 'y_gongJu'
                "
                class="svgDx"
              />
              <div
                class="imgFont"
                :class="{ imgFontColor: triggerHandleTypeIndex == 4 }"
              >
                工具
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box_s" v-else>
      <c-el-empty />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import {ElMessageBox } from 'element-plus'

import CornerstoneMZYL from "@/utils/cornerstoneMZYL"
import CornerstoneWADOImageLoaderMZYL from "@/utils/cornerstoneWADOImageLoaderMZYL"
import CornerstoneToolsMZYL from "@/utils/cornerstoneToolsMZYL"
import thumbnailComponentsDZJP from "@/components/cornerstone/thumbnailComponentsDZJP"
export default {
  components: { thumbnailComponentsDZJP },
  props: {
    seriesInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
       mprConfirm:false,
      imgTiShiBiaoOne: 1, // 1:置灰；2：高亮
      imgTiShiBiaoTwo: 2, // 1:置灰；2：高亮
      triggerHandleTypeIndex: 1,
      triggerHandleTypeIndex_ceLiang: 1,
      triggerHandleTypeIndex_gongJu: 1,
      triggerHandleTypeXuLie: 1,
      tiaoChuangChe: 0,
      thumbnailChe: 0,
      xuLieIs: false,
      tiaoChuangIs: false,
      ceLiangIs: false,
      gongJuIs: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters([
      "imageBrowsing",
      "imageBrowsingViewportList",
      "imageTiaoChuang",
      "useMPR",
      "errorInfo",
      "encryptionEnabledFlag"
    ]),
    dcmNum() {
      return this.seriesInfo.getDcmFilePath.length
    }
  },
  methods: {
    percentagefn(percentage, dcmNum) {
      if (!percentage) {
        return 1
      } else {
        return parseInt(
          (percentage / (dcmNum - 1 <= 0 ? 1 : dcmNum - 1)) * 100
        ) > 100
          ? 100
          : parseInt((percentage / (dcmNum - 1 <= 0 ? 1 : dcmNum - 1)) * 100)
      }
    },
    thumbnailClick(ind) {
      this.thumbnailChe = ind
      CornerstoneMZYL.setSeriesIndex(ind)
      CornerstoneMZYL.DCMRender(null, ind, true)
    },
    triggerHandleType(ind) {
      this.triggerHandleTypeIndex = ind
      // 点击序列
      if (ind === 1) {
        this.triggerHandleTypeIndex_ceLiang = 1
        this.triggerHandleTypeIndex_gongJu = 1
        this.xuLieIs = !this.xuLieIs
        this.tiaoChuangIs = false
        this.ceLiangIs = false
        this.gongJuIs = false
      }
      // 点击调窗
      if (ind === 2) {
        this.triggerHandleTypeIndex_ceLiang = 1
        this.triggerHandleTypeIndex_gongJu = 1
        this.xuLieIs = false
        this.tiaoChuangIs = !this.tiaoChuangIs
        this.ceLiangIs = false
        this.gongJuIs = false
        CornerstoneToolsMZYL.setToolActiveWwwc()
      }
      // 点击测量
      if (ind === 3) {
        this.triggerHandleTypeIndex_gongJu = 1
        this.xuLieIs = false
        this.tiaoChuangIs = false
        this.ceLiangIs = !this.ceLiangIs
        this.gongJuIs = false
        CornerstoneToolsMZYL.setToolActiveType("Length")
      }
      // 点击工具
      if (ind === 4) {
        this.triggerHandleTypeIndex_ceLiang = 1
        this.xuLieIs = false
        this.tiaoChuangIs = false
        this.ceLiangIs = false
        this.gongJuIs = !this.gongJuIs
      }
    },
    triggerHandleTypeGongJuFun(ind, type) {
      this.triggerHandleTypeIndex_gongJu = ind
      this.gongJuIs = false
      // 工具
      CornerstoneToolsMZYL.setToolActiveType(type)
    },
    triggerHandleTypeCeLiangFun(ind, type) {
      if (ind === 5) {
        this.triggerHandleTypeIndex_ceLiang = 1
      } else {
        this.triggerHandleTypeIndex_ceLiang = ind
      }
      this.ceLiangIs = false
      CornerstoneToolsMZYL.setToolActiveType(type)
    },
    tiaoChuangChildFun(item, ind) {
      this.tiaoChuangChe = ind
      this.tiaoChuangIs = false
      CornerstoneToolsMZYL.setToolActiveWwwcPreset(item.value)
    },
    triggerHandleTypeXuLieFun(ind) {
      this.triggerHandleTypeXuLie = ind
      this.xuLieIs = false
      // 获取下标
      this.setViewportList(ind)
    },
    setViewportList(ind) {
      // 1*1
      let viewportList = []
      if (ind === 1) {
        viewportList = [
          {
            style: {
              width: "100%",
              height: "100%"
            },
            ac: true
          }
        ]
      }
      if (ind === 2) {
        viewportList = [
          {
            // style: '100%',
            style: {
              width: "100%",
              height: "50%"
            },
            ac: true
          },
          {
            // style: '100%'
            style: {
              width: "100%",
              height: "50%"
            }
          }
        ]
      }
      if (ind === 3) {
        viewportList = [
          {
            style: {
              width: "50%",
              height: "100%"
            },
            ac: true
          },
          {
            style: {
              width: "50%",
              height: "100%"
            }
          }
        ]
      }
      if (ind === 4) {
        viewportList = [
          {
            style: {
              width: "100%",
              height: "50%"
            },
            ac: true
          },
          {
            style: {
              width: "50%",
              height: "50%"
            }
          },
          {
            style: {
              width: "50%",
              height: "50%"
            }
          }
        ]
      }
      if (ind === 5) {
        viewportList = [
          {
            style: {
              width: "50%",
              height: "50%"
            },
            ac: true
          },
          {
            style: {
              width: "50%",
              height: "50%"
            }
          },
          {
            style: {
              width: "50%",
              height: "50%"
            }
          },
          {
            style: {
              width: "50%",
              height: "50%"
            }
          }
        ]
      }
      if (ind === 6) {
        viewportList = [
          {
            style: {
              width: "50%",
              height: "33.3%"
            },
            ac: true
          },
          {
            style: {
              width: "50%",
              height: "33.3%"
            }
          },
          {
            style: {
              width: "50%",
              height: "33.3%"
            }
          },
          {
            style: {
              width: "50%",
              height: "33.3%"
            }
          },
          {
            style: {
              width: "50%",
              height: "33.3%"
            }
          },
          {
            style: {
              width: "50%",
              height: "33.3%"
            }
          }
        ]
      }
      this.$store.dispatch("setViewportList", viewportList)
      // 更新布局
      this.$nextTick(() => {
        CornerstoneMZYL.updataLayout(this.$refs.viewportItem)
      })
    },
    // 设置选中的viewport
    setViewportAc(index, item, list) {
      list.forEach((_item) => {
        _item.ac = false
      })
      item.ac = true
      CornerstoneMZYL.setViewportActive(this.$refs.viewportItem[index])
    },
    getScrollClick(type) {
      const event = this.$refs.tcSfPathWarpper.scrollLeft
      if (type === 1 && this.imgTiShiBiaoOne === 2) {
        const leftNum = event - 75
        if (leftNum > 0) {
          this.$refs.tcSfPathWarpper.scrollLeft = leftNum
          this.imgTiShiBiaoOne = 2
          this.imgTiShiBiaoTwo = 2
        } else {
          this.$refs.tcSfPathWarpper.scrollLeft = 0
          this.imgTiShiBiaoOne = 1
          this.imgTiShiBiaoTwo = 2
        }
      }
      if (type === 2 && this.imgTiShiBiaoTwo === 2) {
        const rightNum = event + 75
        const AllNum =
          this.$refs.tcSfPathWarpper.scrollWidth -
          this.$refs.tcSfPathWarpper.offsetWidth
        if (rightNum < AllNum) {
          this.$refs.tcSfPathWarpper.scrollLeft = rightNum
          this.imgTiShiBiaoOne = 2
          this.imgTiShiBiaoTwo = 2
        } else {
          this.$refs.tcSfPathWarpper.scrollLeft = AllNum
          this.imgTiShiBiaoOne = 2
          this.imgTiShiBiaoTwo = 1
        }
      }
    },
    getScroll(event) {
      const scrollLeft = event.target.scrollLeft + event.target.offsetWidth
      if (scrollLeft === event.target.offsetWidth) {
        this.imgTiShiBiaoOne = 1
        this.imgTiShiBiaoTwo = 2
      }
      if (
        scrollLeft > event.target.offsetWidth &&
        scrollLeft < event.target.scrollWidth
      ) {
        this.imgTiShiBiaoOne = 2
        this.imgTiShiBiaoTwo = 2
      }
      if (scrollLeft >= event.target.scrollWidth - 1) {
        this.imgTiShiBiaoOne = 2
        this.imgTiShiBiaoTwo = 1
      }
    },
    // 重置底部导航状态
    gongNengClear() {
      this.triggerHandleTypeIndex = 1
      this.triggerHandleTypeIndex_ceLiang = 1
      this.triggerHandleTypeIndex_gongJu = 1
      this.triggerHandleTypeXuLie = 1
      this.tiaoChuangChe = 0
    }
  },
  created() {
      this.$store.dispatch('clearErrorInfo')
      // 默认 wwccActive false
      sessionStorage.setItem('wwccActive', false);
      // 默认 没有wwwcStatus
      sessionStorage.removeItem('wwwcStatus');
  },
  mounted() {
    window.addEventListener('customEventMpr',(ev)=>{
      if(!this.mprConfirm){
        this.mprConfirm = true;
        ElMessageBox.alert('当前序列不支持MPR重建！', '提示', {
        // if you want to disable its autofocus
        // autofocus: false,
          confirmButtonText: '取消',
          callback: (action) => {
            this.mprConfirm = false;
            console.log(action)
            CornerstoneMZYL.onDoubletap()

          },
        })
      }
    })

    this.$store.commit("GET_IMAGE_BROWSING_INFO", [])
    // 设置布局 1*1 
    this.$store.dispatch("setViewportList", [
      {
        style: {
          width: "100%",
          height: "100%"
        },
        ac: true,
        topLeft: [],
        topRight: [],
        bottomRight: [],
        bottomLeft: []
      }
    ])
    CornerstoneWADOImageLoaderMZYL.terminate()
    var params = {
      patientid: this.$route.query.patientid,
      hospcode: this.$route.query.hospcode,
      studyid: this.$route.query.studyid,
      hospdomain: this.$route.query.hospdomain,
      checkTime: this.$route.query.checkTime,
      enterFlag: this.$route.query.enterFlag
    }
    // 初始化UseMPR的状态
    this.$store.dispatch("updateUseMPR", false)
    // 初始化四角标注的tags 
    this.$store.dispatch("resetdefaultMark")
    this.$store
      .dispatch("getImageBrowsingInfo", params)
      .then(() => {
        CornerstoneMZYL.mixin(this)
        CornerstoneToolsMZYL.mixin(this)
        const viewportItem = this.$refs.viewportItem[0]
        // 初始化WADO配置
        CornerstoneWADOImageLoaderMZYL.webWorkerManagerInitialize()
        // 渲染 dcm
        CornerstoneMZYL.setViewportActive(viewportItem)
        CornerstoneMZYL.DCMRender(viewportItem, 0)
        // 工具初始化
        CornerstoneToolsMZYL.EnabledAllTools()
        cornerstoneTools.setToolActive("ZoomTouchPinch", {})
        CornerstoneToolsMZYL.setToolActiveType("StackScroll")
        
      })
      .catch(() => {})
    var paramsTiaoChuang = {
      note: "TCSZ",
      hospCode: this.$route.query.hospcode,
      tcStType: this.$route.query.tcStType
    }
    this.$store
      .dispatch("getImageTiaoChuang", paramsTiaoChuang)
      .then(() => {})
      .catch(() => {})
  },
  deactivated() {
    CornerstoneWADOImageLoaderMZYL.terminate()
  }
}
</script>
<style lang="scss" scope>
@import "../style/imageBrowsing.scss";
._progress {
  width: 100%;
  left: 0;
  bottom: -1px;
  height: 2px;
}
.progress-err{
   width: 100%;
  .el-progress-bar__inner{
    background-color:#ef2f09 !important
  }
}
._warn{
  font-size: 12px;
  text-align: center;
  height: 26px;
  line-height: 26px;
  span{
    margin-left: 4px;
  }
}
._disable{
  color: #999;
  pointer-events: none;
  .imgFont{
    color: #999 !important;
  }
}
</style>
